import '.c3{position:relative;}.ssr-plugin'
import '.ih{width:64px;}.ssr-plugin'
import '.ii{height:64px;}.ssr-plugin'
import '.bk{flex-shrink:0;}.ssr-plugin'
import '.at{position:absolute;}.ssr-plugin'
import '.ij{bottom:-4px;}.ssr-plugin'
import '.cc{right:-4px;}.ssr-plugin'
import '.ds{border-radius:50%;}.ssr-plugin'
import '.ik{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.il{width:32px;}.ssr-plugin'
import '.im{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c3 ih ii bk"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="at ij cc ds ik ai il im"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
